// based on vc-align 2.3.6
import Align from './Align'
export default Align



// WEBPACK FOOTER //
// ./components/align/index.js